// extracted by mini-css-extract-plugin
export var card = "_91-0";
export var expandedCard = "_91-2";
export var paginated = "_91-1";